<template>
<div class="document-preview"
     :class="{ 'document-preview__fullscreen' : isFullscreen }"
     @keydown.esc="isFullscreen = false">
  <div v-if="document"
       class="document-preview__container"
       ref="previewContainer"
  >
    <div v-if="hasDisplayError">
      <q-icon name="broken_image">
        <q-tooltip anchor="top middle" self="bottom middle">
          Er kan geen voorbeeld weergegeven worden. Download het bestand om het te bekijken
        </q-tooltip>
      </q-icon>
    </div>
    <img v-else-if="isImage" :src="$route('asset_management.show_image', document.id)"
         @error="hasDisplayError = true">
    <pdf v-else-if="isPdf"
         :src="$route('asset_management.download_asset', [document.id, `${document.name}.pdf`])"
         ref="pdfPreview"
         @error="hasDisplayError = true" />
    <div v-else>
      <q-icon name="insert_drive_file" />
      <p>{{ document.name }}.{{ document.extension }}</p>
    </div>
  </div>

  <div v-if="buttonsPressent" class="map__buttons">
    <q-btn v-if="!isFullscreen"
           icon="unfold_less"
           dense
           color="white"
           text-color="black"
           @click="$emit('update:document',null)">
      <q-tooltip anchor="top middle" self="bottom middle">
        Sluit voorbeeld
      </q-tooltip>
    </q-btn>
    <q-btn v-if="canFullscreen  && !this.isPdf"
           :icon="isFullscreen ? 'fullscreen_exit' : 'fullscreen'"
           dense
           color="white"
           text-color="black"
           @click="toggleFullscreen(!isFullscreen)">
      <q-tooltip anchor="top middle" self="bottom middle">
        {{ isFullscreen ? 'Sluit volledig scherm' : 'Volledig scherm' }}
      </q-tooltip>
    </q-btn>
  </div>
  <div v-if="isFullscreen"
       class="document-preview__backdrop"
       @click="toggleFullscreen(false)" />
</div>
</template>

<script>
import panzoom from 'panzoom'
import { TYPE_IMAGE } from '~HIOR/constants/documentTypes'
import Pdf from './Pdf'

export default {
  props: {
    document: {
      type: Object,
      required: false,
    },
    canFullscreen: {
      type: Boolean,
      default: true,
    },
  },
  components: { Pdf },
  data: () => ({
    isFullscreen: false,
    hasDisplayError: false,
    pdfPages: 0,
    pdfPage: 0,
    pdfLoading: false,
    panZoomInstance: null,
  }),
  watch: {
    document () {
      this.hasDisplayError = false
    },
  },
  computed: {
    buttonsPressent () {
      return this.document && this.canFullscreen
    },
    isImage () {
      return this.document?.type === TYPE_IMAGE
    },
    isPdf () {
      return this.document?.extension === 'pdf'
    },
  },
  methods: {
    async toggleFullscreen (isFullscreen) {
      if (this.panZoomInstance) {
        this.panZoomInstance.dispose()
        this.panZoomInstance = null
        this.$refs.previewContainer.style = null
      }
      this.isFullscreen = isFullscreen
      if (isFullscreen) this.panZoomInstance = panzoom(this.$refs.previewContainer, {
        bounds: true,
        maxZoom: 10,
        minZoom: 0.5,
      })
    },
  },
}
</script>

<style lang="scss">
.document-preview {
  position: relative;

  &__buttons {
    position: absolute;
    z-index: 1000;
    bottom: 20px;
    right: 10px;

    > * {
      margin-left: 10px
    }
  }

  &__container {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
    background-color: var(--q-dark);

    img {
      width: auto;
      height: 100%;
    }

    div {
      text-align: center;

      .q-icon {
        font-size: 4em;
      }
    }
  }

  &.document-preview__fullscreen {
    position: fixed !important;
    height: 100%;
    padding: 40px;
    top: 0;
    right: 0;
    botom: 0;
    left: 0;
    border: 1px solid;
    z-index: 12000;
    border-radius: 4px;
    background-color: white;

    .document-preview__container {
      overflow: visible;
      z-index: 10;
      position: relative;
      height: 100% !important;
      width: 100% !important;
    }

    .document-preview__buttons {
      bottom: 60px;
      right: 60px;
    }
  }

  &__backdrop {
    position: fixed !important;
    cursor: pointer;
    background-color: var(--q-dark);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}

.mobile {
  .document-preview {
    &.document-preview__fullscreen {
      padding: 10px;

      .document-preview__buttons {
        bottom: 30px;
        right: 20px;
      }
    }
  }
}
</style>
